import React from 'react';
import { Badge, Col, Row } from 'reactstrap';
import { Icon, Block } from '../../../../components/Component'; // Added Block
import { format } from 'date-fns';

const ActiveFiltersDisplay = ({
    // Values from localStorage or state that indicate an active filter
    filterLeadStatus,
    filterRole,
    selectedLeadSourceOptions, // This is `selectedOptions` in parent
    selectedAgent,
    filterLeadLabel,
    selectedFilterTags,
    selectedChannelPartners,
    rangeStart,
    rangeEnd,
    filterSearch, // The search term itself
    // Callbacks
    onClearLeadStatusFilter,
    onClearRoleFilter,
    onClearLeadSourceOption, // For individual lead source badges
    onClearAgentFilter,
    onClearLabelFilter,
    onClearTagFilter, // For individual tag badges
    onClearChannelPartnerFilter, // For individual CP badges
    onClearDateFilter,
    onClearSearchFilter,
    onClearAllFilters,
    // Control for showing "Clear All"
    showClearAll,
}) => {
    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            return format(new Date(dateString), 'dd/MM/yyyy');
        } catch (e) {
            return 'Invalid Date';
        }
    };

    return (
        <Block className={''}>
            <Row className={'d-flex mx-0 py-3 w-100'}>
                <Col xs="12" className="d-flex justify-content-end flex-wrap align-items-center" style={{ gap: '0.5rem' }}>
                    {filterSearch && (
                        <Badge className="selected-option bg-secondary me-1">
                            Search: "{filterSearch}"
                            <Icon
                                name="cross-sm"
                                className="ms-1"
                                style={{ cursor: 'pointer' }}
                                onClick={onClearSearchFilter}
                            />
                        </Badge>
                    )}
                    {filterLeadStatus && (
                        <Badge className="selected-option bg-primary me-1" color="info">
                            Status: {filterLeadStatus}
                            <Icon
                                name="cross-sm"
                                className="ms-1"
                                style={{ cursor: 'pointer' }}
                                onClick={onClearLeadStatusFilter}
                            />
                        </Badge>
                    )}
                    {filterRole && (
                        <Badge className="selected-option bg-primary me-1" color="primary">
                            Role: {filterRole}
                            <Icon
                                name="cross-sm"
                                className="ms-1"
                                style={{ cursor: 'pointer' }}
                                onClick={onClearRoleFilter}
                            />
                        </Badge>
                    )}
                    {selectedLeadSourceOptions && selectedLeadSourceOptions.length > 0 && (
                        selectedLeadSourceOptions.map((option, index) => (
                            <Badge className="selected-option bg-primary me-1" key={`leadsource-${index}`}>
                                Lead Source: {option.label}{' '}
                                <Icon
                                    name="cross-sm"
                                    className="ms-1"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => onClearLeadSourceOption(option)}
                                />
                            </Badge>
                        ))
                    )}
                    {selectedAgent && selectedAgent.value && selectedAgent.label !== 'All Agents' && (
                        <Badge className="selected-option bg-primary me-1" color="primary">
                            Agent: {selectedAgent.label}
                            <Icon
                                name="cross-sm"
                                className="ms-1"
                                style={{ cursor: 'pointer' }}
                                onClick={onClearAgentFilter}
                            />
                        </Badge>
                    )}
                    {filterLeadLabel && (
                        <Badge className="selected-option bg-primary me-1">
                            Label: {filterLeadLabel}
                            <Icon
                                name="cross-sm"
                                className="ms-1"
                                style={{ cursor: 'pointer' }}
                                onClick={onClearLabelFilter}
                            />
                        </Badge>
                    )}
                    {selectedFilterTags && selectedFilterTags.length > 0 && (
                        selectedFilterTags.map((tag, index) => (
                            <Badge className="selected-option bg-info me-1" key={`sel-tag-${index}`}>
                                Tag: {tag.label}{' '}
                                <Icon
                                    name="cross-sm"
                                    className="ms-1"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => onClearTagFilter(tag)}
                                />
                            </Badge>
                        ))
                    )}
                    {selectedChannelPartners && selectedChannelPartners.length > 0 && (
                        selectedChannelPartners.map((partner, index) => (
                            <Badge className="selected-option bg-success me-1" key={`sel-cp-${index}`}>
                                Partner: {partner.label}{' '}
                                <Icon
                                    name="cross-sm"
                                    className="ms-1"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => onClearChannelPartnerFilter(partner)}
                                />
                            </Badge>
                        ))
                    )}
                    {(rangeStart || rangeEnd) && (
                        <Badge className="selected-option bg-warning me-1 text-dark">
                            Date:{' '}
                            {rangeStart ? formatDate(rangeStart) : '...'} - {rangeEnd ? formatDate(rangeEnd) : '...'}
                            <Icon
                                name="cross-sm"
                                className="ms-1"
                                style={{ cursor: 'pointer' }}
                                onClick={onClearDateFilter}
                            />
                        </Badge>
                    )}

                    {showClearAll && (
                        <Badge
                            className="selected-option bg-danger"
                            color="danger"
                            onClick={onClearAllFilters}
                            style={{ cursor: 'pointer' }}
                        >
                            Clear All Filters <Icon name="cross-circle-fill" className="ms-1" />
                        </Badge>
                    )}
                </Col>
            </Row>
        </Block>
    );
};

export default ActiveFiltersDisplay;